/** Edad cumplida a la fecha de referencia (por defecto hoy). */
export function calcularEdad(fechaNacimiento, referencia = new Date()) {
  if (!fechaNacimiento) return null;
  const texto = String(fechaNacimiento).split('T')[0];
  const partes = texto.split('-').map((p) => parseInt(p, 10));
  if (partes.length < 3 || partes.some((n) => Number.isNaN(n))) return null;
  const [y, m, d] = partes;
  const nacimiento = new Date(y, m - 1, d);
  const ref = referencia instanceof Date ? referencia : new Date(referencia);
  if (Number.isNaN(nacimiento.getTime()) || Number.isNaN(ref.getTime())) return null;

  let edad = ref.getFullYear() - nacimiento.getFullYear();
  const diffMes = ref.getMonth() - nacimiento.getMonth();
  if (diffMes < 0 || (diffMes === 0 && ref.getDate() < nacimiento.getDate())) {
    edad -= 1;
  }
  return edad >= 0 ? edad : null;
}

export function textoEdad(fechaNacimiento, referencia) {
  const edad = calcularEdad(fechaNacimiento, referencia);
  if (edad == null) return '—';
  return `${edad} años`;
}
